"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateCurrencyCode = exports.validateCountry = exports.validateLanguage = void 0;
const countries_1 = require("../config/countries");
const currency_1 = require("../config/currency");
const language_1 = require("../config/language");
/**
 * Функция для валидации языка
 * Поддерживаемыми языками считаются те на которые есть файлы с локализацией (файлы должны называть также как и ключ языка)
 */
const validateLanguage = (value) => {
    if (!Object.keys(language_1.availableLocales).includes(value)) {
        throw new Error(`Передан язык, который клиент не поддерживает: ${value}`);
    }
    return value;
};
exports.validateLanguage = validateLanguage;
/**
 * Валидация стран
 * Поддерживаемые берутся из конфигурационного файла
 */
const validateCountry = (value) => {
    if (!countries_1.supportedCountries.includes(value)) {
        throw new Error('Клиент не получил страну');
    }
    return value;
};
exports.validateCountry = validateCountry;
/**
 * Валидация валюты
 * Для поддержки в файл надо добавить код и символ валюты
 */
const validateCurrencyCode = (value) => {
    if (!Object.keys(currency_1.supportedCurrency).includes(value)) {
        throw new Error(`Передана валюта, которую клиент не поддерживает: ${value}`);
    }
    return value;
};
exports.validateCurrencyCode = validateCurrencyCode;
